export default __webpack_public_path__ + "static/media/mp3.45fd85ee.png";